import type { PostHogConfig } from "posthog-js";
import {
  PostHogProvider as PostHogProviderImpl,
  usePostHog,
} from "posthog-js/react";
import { type ReactNode, useEffect, useState } from "react";

type Props = {
  apiKey?: string;
  options?: Partial<PostHogConfig>;
  client?: never;
  children: ReactNode;
  /** Fallback to render while PostHog is initialising. */
  fallback: ReactNode;
};

export function PostHogProvider(props: Props) {
  return (
    <PostHogProviderImpl
      apiKey={props.apiKey ?? "debug"}
      options={props.options}
    >
      <FeatureFlagsLoader {...props} />
    </PostHogProviderImpl>
  );
}

function FeatureFlagsLoader(props: Props) {
  const [flagsLoaded, setFlagsLoaded] = useState(false);
  const posthog = usePostHog();

  useEffect(() => posthog.onFeatureFlags(() => setFlagsLoaded(true)));

  if (!flagsLoaded) {
    return props.fallback;
  }

  return props.children;
}
